import { QueryOptions } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'

type Api = ReturnType<typeof useApi>

export const scheduledTasksOptions = (api: Api) => {
  return {
    queryKey: ['logs/scheduled-tasks'],
    queryFn: () => api.logs.getScheduledTasks(),
  } satisfies QueryOptions
}
